import { getResponseQuery } from "@helpers/_functions";

import http from "../../http-common";
import BaseService from "../base.service";

class EvaluationRequestTemplate extends BaseService {
  constructor() {
    super("evaluation-request-templates");
  }

  duplicate(evaluationRequestTemplateId) {
    return getResponseQuery(
      http.post(`${this.path}/duplicate/${evaluationRequestTemplateId}`)
    );
  }
}

export default new EvaluationRequestTemplate();
